import { http } from "../utils/http";

export const loginWithPasswordApi = async (payload: { email: string, password: string }) => {
  return await http.post("/v1/auth/admin/login/password", payload, false)
};

export const logoutApi = async () => {
  return await http.post("/v1/auth/logout", null)
};
